export default __webpack_public_path__ + "static/media/save_ic.80037e3b.svg";